import cartStepHtml from './cartstep.component.html';
import './cartstep.component.scss';

class CartStepController {
    constructor($scope, CartService) {
        'ngInject';

        this.$scope = $scope;
        this.service = CartService;
    }

    get step() {
        if (this.service.loaded)
            return this.service.step;

        return parseInt(this.initialStep) || 1;
    }
}

let cartStepComponent = {
    bindings: {
        initialStep: '<'
    },
    template: cartStepHtml,
    controller: CartStepController
}

export default cartStepComponent;